import { formatBookingTime, mileageStatus } from "./bookingUtils.js";

import { correctMileage } from "./actions.js";

const dateFormatter = new Intl.DateTimeFormat("en-GB", {
    "day": "2-digit",
    "month": "short",
    "year": "numeric",
});

export default {
    "label": "Pool Car Bookings",
    "key": "PoolCarBooking",
    "location": "PoolCarBooking/Bookings/",
    "headers": [{
        "headerName": "Start Date",
        "field": "Start",
        valueFormatter({ value }) {
            return dateFormatter.format(new Date(Number(value)));
        }
    }, {
        "headerName": "End Date",
        "field": "End",
        valueFormatter({ value }) {
            const endDate = new Date(Number(value));
            if (endDate.getHours() === 0) endDate.setDate(endDate.getDate() - 1);
            return dateFormatter.format(endDate);
        }
    }, {
        "headerName": "Time",
        valueFormatter({ data }) {
            return formatBookingTime(data);
        }
    }, {
        "headerName": "Booked By",
        "field": "UserName"
    }, {
        "headerName": "Purpose",
        "field": "Purpose"
    }, {
        "headerName": "Mileage Status",
        valueFormatter({ data }) {
            return mileageStatus(data);
        }
    }, {
        "headerName": "Pickup Mileage",
        "field": "Mileage.Start.Value"
    }, {
        "headerName": "Return Mileage",
        "field": "Mileage.End.Value"
    }, {
        "headerName": "Distance",
        "field": "Mileage.Distance"
    }],
    "actions": [],
    "rowActions": [{
        "label": "Correct Mileage",
        "action": correctMileage,
        "security": "General.ApplicationAdmin",
        show({ rowItem }) {
            return [
                rowItem?.Mileage?.StartRecorded === true || rowItem?.Mileage?.EndRecorded === true,
                "No mileage has been recorded.",
            ];
        },
    }]
};
